import { render, staticRenderFns } from "./tableInfo.vue?vue&type=template&id=080b868d&scoped=true"
import script from "./tableInfo.vue?vue&type=script&lang=js"
export * from "./tableInfo.vue?vue&type=script&lang=js"
import style0 from "./tableInfo.vue?vue&type=style&index=0&id=080b868d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b868d",
  null
  
)

export default component.exports